/**
 * App.jsx
 *
 * Application root component.
 *
 * Intentionally minimal — all routing, providers, and layout are
 * handled inside <Routes />. This keeps App.jsx as a clean entry
 * point and avoids nested router errors.
 *
 * Architecture rule: NEVER add <BrowserRouter>, <Route>, or any
 * routing components here. All routing lives in Routes.jsx.
 */

import React from 'react';
import Routes from './Routes';

function App() {
  return <Routes />;
}

export default App;
